import { Grid } from "@mui/material";
import { fDate } from "../../../utils/formatTime";

const RequiredEligibility = (_props) => {
    const { candidateData, className } = _props
    return (
        <fieldset className={Number(
            candidateData?.is_your_name_registered_any_district_employment
        ) === 1
            ? `${className}--fieldset categoryDetails`
            : `${className}--fieldset categoryDetails print-break`}>
            <legend className={`${className}--legend`}>
                Required Eligibility
            </legend>
            {/* for web preview */}
            <div className="print-web">
                <Grid container spacing={3} alignItems={"center"}>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            1.
                        </span>
                        <p className={`${className}--text`}>
                            Is your name registered in any District Employment
                            Office located in Uttarakhand State?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_your_name_registered_any_district_employment
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                    {Number(
                        candidateData?.is_your_name_registered_any_district_employment
                    ) === 1 && (
                            <>
                                <Grid item lg={6} md={6} sm={6} xs={6} display="flex"
                                    flexDirection={"row"}
                                    alignItems="center">
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(i).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Employee Registration Number
                                    </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6} >
                                    <p className={`${className}--subText`}>
                                        {
                                            candidateData?.registered_any_district_employment_reg_no
                                        }
                                    </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6} display="flex"
                                    flexDirection={"row"}
                                    alignItems="center">
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(ii).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Employment Office District
                                    </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <p className={`${className}--subText`}>
                                        {
                                            candidateData?.registered_any_district_employment_ofc_district
                                        }
                                    </p>
                                </Grid>{" "}
                                <Grid item lg={6} md={6} sm={6} xs={6} display="flex"
                                    flexDirection={"row"}
                                    alignItems="center">
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(iii).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Date of Registration
                                    </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <p className={`${className}--subText`}>
                                        {
                                            fDate(candidateData?.registered_any_district_employment_date_of_registration, 'dd/MM/yyyy')
                                        }
                                    </p>
                                </Grid>{" "}
                                <Grid item lg={6} md={6} sm={6} xs={6} display="flex"
                                    flexDirection={"row"}
                                    alignItems="center">
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(iv).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Registration Date Valid Upto
                                    </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                    <p className={`${className}--subText`}>
                                        {
                                            fDate(candidateData?.registered_any_district_employment_registration_date_valid_upto, 'dd/MM/yyyy')
                                        }
                                    </p>
                                </Grid>
                            </>
                        )}

                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            2.
                        </span>
                        <p className={`${className}--text`}>
                            Are You Employed?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(candidateData?.is_employed) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                    {Number(candidateData?.is_employed) === 1 && (
                        <>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                sm={6}
                                xs={6}
                                display="flex"
                                flexDirection={"row"}
                                alignItems="center"
                            >
                                <span
                                    className={`${className}--text`}
                                    style={{ marginRight: "10px" }}
                                >
                                    2(i).
                                </span>
                                <p className={`${className}--text`}>
                                    Type of Organisation
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.employee_organization_type}
                                </p>
                            </Grid>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                sm={6}
                                xs={6}
                                display="flex"
                                flexDirection={"row"}
                                alignItems="center"
                            >
                                <span
                                    className={`${className}--text`}
                                    style={{ marginRight: "10px" }}
                                >
                                    2(ii).
                                </span>
                                <p className={`${className}--text`}>
                                    Date of Applying NOC
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(
                                        candidateData?.employee_organization_noc,
                                        "dd/MM/yyyy"
                                    )}
                                </p>
                            </Grid>{" "}
                        </>
                    )}
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            3.
                        </span>
                        <p className={`${className}--text`}>
                            Have you passed your High School and Intermediate or
                            any other equivalent exam from any recognized
                            institution situated in the State of Uttarakhand?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_passed_hs_s_school_any_other_exam
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            4(i).
                        </span>
                        <p className={`${className}--text`}>
                            Are you or your spouse or your parents regular
                            employees of the Armed Forces/Paramilitary Forces
                            serving in the state of Uttarakhand and whose
                            services cannot be transferred outside the state of
                            Uttarakhand?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_your_spouse_parents_regular_employees_forces
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            4(ii).
                        </span>
                        <p className={`${className}--text`}>
                            Are you or your spouse or your parents regular
                            employees of the State Government/Semi Government
                            organisation serving on a regular basis in the state
                            of Uttarakhand and whose services cannot be
                            transferred outside the state of Uttarakhand?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_your_spouse_parents_regular_employees_state_govt
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            4(iii).
                        </span>
                        <p className={`${className}--text`}>
                            Are you or your spouse or your parents regular
                            employees of Central Government organisation/
                            Central Government Public Service Undertaking and
                            are working regularly in the State of Uttarakhand
                            and whose services cannot be transferred outside the
                            State of Uttarakhand
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_your_spouse_parents_regular_employees_central_govt
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            5(i).
                        </span>
                        <p className={`${className}--text`}>
                            Are you permanent resident of Uttarakhand but
                            residing outside Uttarakhand for
                            livelihood/education purposes?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_permanent_resident_of_uk_but_reside_uk
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            5(ii).
                        </span>
                        <p className={`${className}--text`}>
                            Is your spouse or your parents permanent residents
                            of Uttarakhand but are residing outside Uttarakhand
                            for livelihood/education purposes?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_spouse_parents_permanent_resident_of_uk_but_reside_outside_uk
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </Grid>
                </Grid>
            </div>
            {/* for print preview */}
            <div className="print-view">
                <div className="print-details d-flex">
                    <div className="w-80 d-flex ">
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            1.
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Is your name registered in any District Employment
                            Office located in Uttarakhand State?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`${className}--subText txtRight`}>
                            {Number(
                                candidateData?.is_your_name_registered_any_district_employment
                            ) === 1
                                ? "Yes"
                                : "No"}
                        </p>
                    </div>
                </div>
                {Number(
                    candidateData?.is_your_name_registered_any_district_employment
                ) === 1 && (
                        <>
                            <div className="print-details d-flex">
                                <div className="w-80 d-flex" >
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(i).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Employee Registration Number
                                    </p>
                                </div>
                                <div className="w-20">
                                    <p className={`${className}--subText`}>
                                        {
                                            candidateData?.registered_any_district_employment_reg_no
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className="print-details d-flex">
                                <div
                                    className="w-80 d-flex"
                                    style={{ marginRight: "10px" }}
                                >
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(ii).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Employment Office District
                                    </p>
                                </div>
                                <div className="w-20">
                                    <p className={`${className}--subText`}>
                                        {
                                            candidateData?.registered_any_district_employment_ofc_district
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className="print-details d-flex">
                                <div
                                    className="w-80 d-flex"
                                    style={{ marginRight: "10px" }}
                                >
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(iii).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Date of Registration
                                    </p>
                                </div>
                                <div className="w-20">
                                    <p className={`${className}--subText`}>
                                        {
                                            fDate(candidateData?.registered_any_district_employment_date_of_registration, 'dd/MM/yyyy')
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className="print-details d-flex">
                                <div
                                    className="w-80 d-flex"
                                    style={{ marginRight: "10px" }}
                                >
                                    <span
                                        className={`${className}--text`}
                                        style={{ marginRight: "10px" }}
                                    >
                                        1(iv).
                                    </span>
                                    <p className={`${className}--text`}>
                                        Registration Date Valid Upto
                                    </p>
                                </div>
                                <div
                                    className="w-20"
                                >
                                    <p className={`${className}--subText`}>
                                        {
                                            fDate(candidateData?.registered_any_district_employment_registration_date_valid_upto, 'dd/MM/yyyy')
                                        }
                                    </p>
                                </div>
                            </div>
                        </>
                    )}
                <div className="print-details d-flex">
                    <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            2.
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Are You Employed?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(candidateData?.is_employed) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </div>
                </div>
                {Number(candidateData?.is_employed) === 1 && (
                    <>
                        <div className="print-details d-flex">
                            <div
                                className="w-80 d-flex"
                                style={{ marginRight: "10px" }}
                            >
                                <span
                                    className={`${className}--text`}
                                    style={{ marginRight: "10px" }}
                                >
                                    2(i).
                                </span>
                                <p className={`${className}--text`}>
                                    Type of Organisation
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {candidateData?.employee_organization_type}
                                </p>
                            </div>
                        </div>
                        <div className="print-details d-flex">
                            <div
                                className="w-80 d-flex"
                                style={{ marginRight: "10px" }}
                            >
                                <span
                                    className={`${className}--text`}
                                    style={{ marginRight: "10px" }}
                                >
                                    2(ii).
                                </span>
                                <p className={`${className}--text`}>
                                    Date of Applying NOC
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.employee_organization_noc, 'dd/MM/yyyy')}
                                </p>
                            </div>
                        </div>
                    </>
                )}
                <div className="print-details d-flex">
                    <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            3.
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Have you passed your High School and Intermediate or
                            any other equivalent exam from any recognized
                            institution situated in the State of Uttarakhand
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_passed_hs_s_school_any_other_exam
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            4(i).
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Are you or your spouse or your parents regular
                            employees of the Armed Forces/Paramilitary Forces
                            serving in the state of Uttarakhand and whose
                            services cannot be transferred outside the state of
                            Uttarakhand?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_your_spouse_parents_regular_employees_forces
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            4(ii).
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Are you or your spouse or your parents regular
                            employees of the State Government/Semi Government
                            organisation serving on a regular basis in the state
                            of Uttarakhand and whose services cannot be
                            transferred outside the state of Uttarakhand?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_your_spouse_parents_regular_employees_state_govt
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            4(iii).
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Are you or your spouse or your parents regular
                            employees of Central Government organisation/
                            Central Government Public Service Undertaking and
                            are working regularly in the State of Uttarakhand
                            and whose services cannot be transferred outside the
                            State of Uttarakhand?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_your_spouse_parents_regular_employees_central_govt
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </div>
                </div>
                <div className="print-details d-flex">
                    <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            5(i).
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Are you permanent resident of Uttarakhand but
                            residing outside Uttarakhand for
                            livelihood/education purposes?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_permanent_resident_of_uk_but_reside_uk
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </div>
                </div>
                {/* ******* */}
                <div className="print-details d-flex">
                    <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                    >
                        <span
                            className={`${className}--text`}
                            style={{ marginRight: "10px" }}
                        >
                            5(ii).
                        </span>
                        <p className={`${className}--text`}>
                            {" "}
                            Is your spouse or your parents permanent residents
                            of Uttarakhand but are residing outside Uttarakhand
                            for livelihood/education purposes?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`"${className}--subText custom-rht2`}>
                            <p className={`${className}--subText`}>
                                {Number(
                                    candidateData?.is_spouse_parents_permanent_resident_of_uk_but_reside_outside_uk
                                ) === 1
                                    ? "Yes"
                                    : "No"}
                            </p>
                        </p>
                    </div>
                </div>
            </div>
        </fieldset>
    )
}

export default RequiredEligibility;